/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState, useCallback } from 'react';
import { inject, observer } from 'mobx-react';
import { useIntl } from 'umi';
import classnames from 'classnames/bind';
import RTCModel from '@/models/rtc';
import UserModel from '@/models/user';
import MeetingModal from '@/models/meeting';
import { Icon } from '@/components';
import ViewBox, { viewBoxType } from '../ViewBox';
import H5MainStream from './components/H5MainStream';
import Style from './index.less';

const $c = classnames.bind(Style);

interface ViewPanelProps {
  meeting?: MeetingModal;
  RTCInstance?: RTCModel;
  user?: UserModel;
}

const Only: React.FC<ViewPanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    RTCInstance: store.rtc,
    user: store.user,
  };
})(
  observer((props: ViewPanelProps) => {
    const { meeting, user } = props;

    const [showPeopleList, setShowPeopleList] = useState(false);
    const { formatMessage } = useIntl();

    const renderShareInfo = useCallback(
      (mid: string) => {
        return (
          <>
            {meeting?.getMemberInfoByMid(mid)?.memberName}
            {mid === user?.mid && `(${formatMessage({ id: 'ME' })})`}
          </>
        );
      },
      [user, meeting],
    );

    useEffect(() => {}, [meeting?.speakerName]);

    return (
      <div className={$c('view-panel-wrap', 'only-share')}>
        <div className={$c('wrap-top', 'show-people-list', { hide: !showPeopleList })}>
          <div className={$c('scroller')}>
            <div className={$c('people-list')}>
              {meeting?.sortYxuids.map(yxuid => (
                <div key={yxuid} className={$c('people-item')}>
                  <ViewBox yxuid={yxuid} type={viewBoxType.video} className={$c('people-item-viewbox')} />
                </div>
              ))}
            </div>
          </div>
          <div
            className={$c('up')}
            onClick={() => {
              setShowPeopleList(false);
            }}
          >
            <Icon className={$c('up-icon')} name="icon-shouqi" mode="symbol" />
          </div>
        </div>
        <div
          className={$c('wrap-top', { hide: showPeopleList })}
          onClick={() => {
            if (!showPeopleList) {
              setShowPeopleList(true);
            }
          }}
        >
          {!!meeting?.screenUid && (
            <div className={$c('share')}>
              {meeting?.screenUid && <Icon className={$c('icon')} name="icon-a-Mirrorshare" />}
              <span className={$c('name')}>{meeting?.screenUid && renderShareInfo(meeting.screenUid)}</span>
            </div>
          )}
          <div className={$c('speaker')}>
            <Icon className={$c('icon', { 'no-speaker': !meeting?.speakerYxUid })} name="icon-speaking" />
            {meeting?.speakerName && (
              <span className={$c('name')}>
                {meeting.speakerName}
                {meeting.speakerYxUid === user?.yxuid && `(${formatMessage({ id: 'ME' })})`}
              </span>
            )}
          </div>
          <div className={$c('placeholder')} />
          <Icon className={$c('down')} name="icon-arrow_line_down" />
        </div>
        <H5MainStream />
      </div>
    );
  }),
);

export default Only;
